import { borraRolesXUser, creaRolesXUser, getRolesOpem, getUsuariosByRol } from '../../services/Roles/RolesService';
import { useEffect, useRef, useState } from 'react';

export const useAsignaRoles = () => {
    const [rol, setRol] = useState();
    const [lstRoles, setLstRoles] = useState([]);
    const [cargaRoles, setCargaRoles] = useState(false);

    const [usuario, setUsuario] = useState();
    const [lstUsuarios, setLstUsuarios] = useState([]);
    const [cargaUsuarios, setCargaUsuarios] = useState(false);
    const [reloadUsuario, setReloadUsuario] = useState(false);

    const [visibleAdicion, setVisibleAdicion] = useState(false);
    const [visibleElimina, setVisibleElimina] = useState(false);

    const miToast = useRef();

    useEffect(() => {
        const recuperaRoles = async () => {
            try {
                setCargaRoles(true);
                const roles = await getRolesOpem();
                //console.log('XX01:', roles)
                setLstRoles(roles);
            } catch (error) {
                console.error('ERROR: ', error.message);
            } finally {
                setCargaRoles(false);
            }
        };
        recuperaRoles();
    }, []);

    useEffect(() => {
        const recuperaUsuarioXRol = async () => {
            if (rol) {
                try {
                    setCargaUsuarios(true);
                    const resUsuarios = await getUsuariosByRol(rol.codigo);
                    //console.log('JJ00:', resUsuarios);
                    setLstUsuarios(resUsuarios);
                } catch (error) {
                    console.error('ERROR:', error.message);
                } finally {
                    setCargaUsuarios(false);
                }
            }
        };
        recuperaUsuarioXRol();
    }, [rol, reloadUsuario]);

    const abreAdiUsuario = () => {
        //console.log('ff:', rol);
        if (rol) {
            setVisibleAdicion(true);
        }
        miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe seleccionar un Rol' });
        return;
    };

    const guardaUsuario = async (formData) => {
        if (!rol) {
            miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe seleccionar un Rol' });
            return;
        }
        if (!formData.listaUser) {
            miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe seleccionar un usuario' });
            return;
        }
        const objPost = {
            rolId: rol.configuracionDetId,
            listUsuarioId: formData.listaUser
        };
        try {
            const respuesta = await creaRolesXUser(objPost);
            miToast.current.show({ severity: 'success', summary: 'Exito', detail: 'Se ha guardado los datos' });
            setReloadUsuario((prev) => !prev);
            setVisibleAdicion(false);
        } catch (err) {
            miToast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al ejecutar proceso' });
            console.error('ERROR: ', err.message);
        }
    };

    const abreELiUsuario = () => {
        if (!rol) {
            miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe seleccionar un Rol' });
            return;
        }
        if (!usuario || usuario.length === 0) {
            miToast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe seleccionar algunos Usuarios' });
            return;
        }
        setVisibleElimina(true);
    };

    const eliminaUsuario = async () => {
        //const listaIds = usuarioSelect.filter((item) => Number.isInteger(item.usuarioId)).map((item) => item.usuarioId);
        const usuarioIds = usuario.filter((item) => Number.isInteger(item.usuarioId)).map((item) => item.usuarioId);
        const objPost = {
            rolId: rol.configuracionDetId,
            listUsuarioId: usuarioIds
        };
        try {
            const respuesta = await borraRolesXUser(objPost);
            miToast.current.show({ severity: 'success', summary: 'Exito', detail: 'Usuarios eliminados del Rol' });
            setReloadUsuario((prev) => !prev);
            setUsuario([])
        } catch (error) {
            console.error('ERROR: ', error.message);
            miToast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al ejecutar proceso' });
        } finally {
            setVisibleElimina(false);
        }
    };

    return { miToast, visibleAdicion, setVisibleAdicion, guardaUsuario, visibleElimina, setVisibleElimina, rol, eliminaUsuario, cargaRoles, setRol, lstRoles, cargaUsuarios, usuario, lstUsuarios, setUsuario, abreAdiUsuario, abreELiUsuario };
};
